import onAddCrisisAllocation from './onAddCrisisAllocation';
import onAddCrisisAllocationManual from './onAddCrisisAllocationManual';
import onEditCrisisAllocation from './onEditCrisisAllocation';
import onDeleteCrisisAllocation from './onDeleteCrisisAllocation';
import onGetCrisisCalls from './onGetCrisisCalls';
import onEditCrisisAddress from './onEditCrisisAddress';
import onEditManualCrisisAllocationAddress from './onEditManualCrisisAllocationAddress';
import onGetCrisisCallTeamMembers from './onGetCrisisCallTeamMembers';
import onCrisisCallResolve from './onCrisisCallResolve';

export default {
  onAddCrisisAllocation,
  onAddCrisisAllocationManual,
  onEditCrisisAllocation,
  onDeleteCrisisAllocation,
  onGetCrisisCalls,
  onEditCrisisAddress,
  onEditManualCrisisAllocationAddress,
  onGetCrisisCallTeamMembers,
  onCrisisCallResolve,
};
